import React from 'react';
import { PageLayout } from '../../components/page-layout';
import { OnboardingProgressBar } from '../../components/onboarding-progress-bar';
import { useOnboarding } from '../../providers/onboarding-provider';
import { OnboardingForm } from '../../components/onboarding/OnboardingForm';

export const PreferencesPage = () => {
  const { completeStep } = useOnboarding();

  return (
    <PageLayout>
      <div className="content-layout">
        <OnboardingProgressBar />
        <OnboardingForm
          stepKey="PREFERENCES"
          onComplete={() => completeStep('PREFERENCES')}
        />
      </div>
    </PageLayout>
  );
};
